import React from 'react';
import { Shield, Lock, Eye, FileText, Database, Globe } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="pt-32 pb-16 bg-[#061225] min-h-screen text-gray-300 font-sans">
      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 relative z-10">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Privacy <span className="text-[#0EA5E9]">Policy</span></h1>
          {/* <p className="text-gray-400">Last updated: {new Date().toLocaleDateString()}</p> */}
        </div>

        <div className="space-y-8 bg-[#0F1629] p-8 md:p-10 rounded-2xl border border-white/5 shadow-2xl">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
              <Shield className="w-6 h-6 text-[#0EA5E9]" />
              1. Introduction
            </h2>
            <p className="leading-relaxed text-gray-400">
              Welcome to VishwaDigitech. We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you as to how we look after your personal data when you visit our website and tell you about your privacy rights and how the law protects you.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
              <Database className="w-6 h-6 text-emerald-400" />
              2. Data We Collect
            </h2>
            <p className="leading-relaxed text-gray-400 mb-4">
              We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-gray-400">
              <li><strong>Identity Data:</strong> includes first name, last name, username or similar identifier.</li>
              <li><strong>Contact Data:</strong> includes email address and telephone numbers.</li>
              <li><strong>Technical Data:</strong> includes internet protocol (IP) address, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform, and other technology on the devices you use to access this website.</li>
              <li><strong>Usage Data:</strong> includes information about how you use our website, products and services.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
              <Globe className="w-6 h-6 text-violet-500" />
              3. How We Use Your Data
            </h2>
            <p className="leading-relaxed text-gray-400 mb-4">
              We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-gray-400">
              <li>Where we need to perform the contract we are about to enter into or have entered into with you.</li>
              <li>Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.</li>
              <li>Where we need to comply with a legal obligation.</li>
              <li>To improve our website, products/services, marketing, customer relationships and experiences.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
              <Lock className="w-6 h-6 text-[#0EA5E9]" />
              4. Data Security
            </h2>
            <p className="leading-relaxed text-gray-400">
              We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors and other third parties who have a business need to know.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
              <Eye className="w-6 h-6 text-emerald-400" />
              5. Third-Party Links
            </h2>
            <p className="leading-relaxed text-gray-400">
              This website may include links to third-party websites, plug-ins and applications. Clicking on those links or enabling those connections may allow third parties to collect or share data about you. We do not control these third-party websites and are not responsible for their privacy statements.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
              <FileText className="w-6 h-6 text-violet-500" />
              6. Your Legal Rights
            </h2>
            <p className="leading-relaxed text-gray-400 mb-4">
              Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-gray-400">
              <li>Request access to your personal data.</li>
              <li>Request correction of your personal data.</li>
              <li>Request erasure of your personal data.</li>
              <li>Object to processing of your personal data.</li>
              <li>Request restriction of processing your personal data.</li>
              <li>Request transfer of your personal data.</li>
              <li>Right to withdraw consent.</li>
            </ul>
          </section>

          <section className="pt-4 border-t border-white/10">
            <h2 className="text-2xl font-bold text-white mb-4">7. Contact Us</h2>
            <p className="leading-relaxed text-gray-400">
              If you have any questions about this privacy policy or our privacy practices, please contact us at:
            </p>
            <div className="mt-4 bg-white/5 p-4 rounded-xl inline-block border border-white/10">
              <p className="text-white font-medium">VishwaDigitech</p>
              <p className="text-gray-400 mt-1 flex items-center gap-2"><Globe className="w-4 h-4 text-gray-500"/> Website: <a href="https://vishwadigitech.com" className="text-gray-400 hover:text-white transition-colors">vishwadigitech.com</a></p>
              <p className="text-gray-400 mt-1 flex items-center gap-2">Email: <a href="mailto:info@vishwadigitech.com" className="text-[#0EA5E9] hover:underline">info@vishwadigitech.com</a></p>
              <p className="text-gray-400 mt-1 flex items-center gap-2">Phone: <a href="tel:+919699938509" className="text-emerald-400 hover:underline">+91 9699938509</a></p>
              <p className="text-gray-400 mt-2 text-sm">Address: 2nd floor, V S Khandekar Vachanalay, Sangli, Khanbhag, Sangli Miraj Kupwad, Maharashtra 416416</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
